

const Timeline = (props) => {
    // console.log(props);

    const timelineEdu = props.timelineEdu;
    // console.log(timelineEdu);
    const data1 = timelineEdu?.map((item, index) => {
        return <div className="timeline-item d-flex position-relative" key={item.id}>
            <div className="right-part">
                <span className="item-period d-inline-block">{item.title1}</span>
                <span className="item-sub d-block">{item.title2}</span>
            </div>
            <div className="divider-item"></div>
            <div className="left-part">
                <h5>{item.title3}</h5>
                <p>
                    {item.summary}
                </p>
            </div>
        </div>
    })

    return (
        <div className="timeline">
            {data1}
        </div>

    )
}
export default Timeline;